define('tinymce-plugins/wa5_image/plugin',['tinymce/AddOnManager', "tinymce/ui/Widget", "tinymce/ui/Factory",
		"tinymce/html/Serializer", "tinymce/html/Schema",
		"tinymce/html/DomParser", "tinymce-plugins/wa5_image/upload-dialog",
		"tinymce-plugins/wa5_image/image-utils"],
function(AddOnManager, Widget, Factory, Serializer, Schema, DomParser, UploadDialog, imageUtils) {
	var globalIDs = {
		_id: 0,

		next: function() {
			this._id++;
			return 'wa5-id-' + this._id;
		}
	};

	AddOnManager.PluginManager.add('wa5_image', function(editor) {
		function showDialog() {
			var imgElement = editor.selection.getNode();
			var imageDefinition = null;
			var dialog = new UploadDialog();

			var data = {};
			if (imgElement.nodeName == 'IMG' && !imgElement.getAttribute('data-mce-object')) {
				imageDefinition = JSON.parse(editor.dom.getAttrib(imgElement, 'data-definition'));
				if (imageDefinition.type != 'image') {
					imageDefinition = null;
					imgElement = null;
				}
			} else {
				imgElement = null;
			}

			dialog.on('insert', function(data) {
				var imageDefinition = data;
				imageDefinition.type = 'image';
				imageDefinition.src_x = 0;
				imageDefinition.src_y = 0;
				imageDefinition.src_w = -1;
				imageDefinition.src_h = -1;

				// limit width/height if adding image (not editing)
				if (!imgElement)
					imageUtils.boxSize(imageDefinition);

				var imageData = {
					'class': 'image',
					src: imageUtils.getImageURL(imageDefinition),
					width: imageDefinition.width,
					height: imageDefinition.height,
					alt: 'Image #' + imageDefinition.id,
					'data-definition': JSON.stringify(imageDefinition)
				};

				if (!imgElement) {
					imageData.id = '__mcenew';
					editor.insertContent(editor.dom.createHTML('img', imageData));
					imgElement = editor.dom.get('__mcenew');
					editor.dom.setAttrib(imgElement, 'id', null);
				} else {
					editor.dom.setAttribs(imgElement, imageData);
				}

				editor.selection.select(imgElement);
				editor.nodeChanged();
			});

			if (imageDefinition) {
				dialog.showEditor(imageDefinition);
			} else {
				dialog.showUpload();
			}
		}

		editor.addButton('wa5_image', {
			icon: 'image',
			tooltip: 'Insert/edit image',
			onclick: showDialog,
			stateSelector: 'img:not([data-mce-object]):not(.math)'
		});

		editor.addMenuItem('wa5_image', {
			icon: 'image',
			text: 'Insert image',
			onclick: showDialog,
			context: 'insert',
			prependToContext: true
		});

		editor.addCommand('wa5_image', showDialog);

		// save image size
		editor.on('ObjectResized', function(e) {
			var imgElement = e.target;
			if (imgElement && imgElement.hasAttribute('data-definition')) {
				var imageDefinition =
					JSON.parse(imgElement.getAttribute('data-definition'));
				if (imageDefinition.type == 'image') {
					imageDefinition.width = e.target.width;
					imageDefinition.height = e.target.height;
					imgElement.setAttribute('data-definition',
							JSON.stringify(imageDefinition));
				}
			}
		});

		// convert <wa5-image> elements to <img> elements
		editor.on('BeforeSetContent', function(e) {
			// Need to tell the parser that <wa5-image> is shortended
			var schema = Object.create(editor.schema);
			schema.getShortEndedElements = function() {
				var map = editor.schema.getShortEndedElements();
				map['wa5-image'] = {};
				map['wa5-math'] = {};
				return map;
			};
			var parser = new DomParser({validate: false}, schema);
			var tree = parser.parse(e.content, {isRootContent: true});

			if (tree)
				walk(tree);

			// clone the settings to disable validation
			var settings = $.extend(true, {}, editor.settings);
			settings.verify_html = false;
			schema = new Schema(settings);
			var serializer = new Serializer({validate: false}, schema);
			e.content = serializer.serialize(tree);

			function walk(node) {
				if (node.name == 'wa5-image') {
					var definition = {type: 'image', id: null, filename: null, width: null,
						height: null, ownwork: null, license: null,
						author: null, source: null, src_w: -1, src_h: -1,
						src_x: 0, src_y: 0};
					var styleAttr = null;
					for (var i = 0; i < node.attributes.length; i++) {
						var name = node.attributes[i].name;
						if (name in definition)
							definition[name] = node.attributes[i].value;
						if (node.attributes[i].name == 'style')
							styleAttr = node.attributes[i];
					}
					definition.width = parseInt(definition.width);
					definition.height = parseInt(definition.height);
					definition.ownwork = definition.ownwork == 'yes';

					var id = globalIDs.next();

					node.name = 'img';
					node.attributes = [
						{name: 'class', value: 'image'},
						{name: 'src', value: ''},
						{name: 'alt', value: ''},
						{name: 'width', value: definition.width + ""},
						{name: 'height', value: definition.height + ""},
						{name: 'data-definition', value: JSON.stringify(definition)},
						{name: 'src', value: imageUtils.getImageURL(definition)},
						{name: 'id', value: id}];
					if (styleAttr)
						node.attributes.push(styleAttr);
					node.shortEnded = true;
				}

				if ((node = node.firstChild)) {
					do {
						walk(node);
					} while ((node = node.next));
				}
			}
		});

		// convert <img> elements to <wa5-image> elements
		editor.on('SaveContent', function(e) {
			var parser = new DomParser({validate: false}, schema);
			var tree = parser.parse(e.content, {isRootContent: true});

			if (tree)
				walk(tree);

			// clone the settings
			var settings = $.extend(true, {}, editor.settings);
			settings.verify_html = false;
			var schema = new Schema(settings);
			e.content = new Serializer({validate: false}, schema).serialize(tree);

			function walk(node) {
				if (node.name == 'img') {
					var definition = null;
					var styleAttr = null;
					for (var i = 0; i < node.attributes.length; i++) {
						if (node.attributes[i].name == 'data-definition') {
							definition = JSON.parse(node.attributes[i].value);
							break;
						}
						if (node.attributes[i].name == 'style')
							styleAttr = node.attributes[i];
					}
					if (definition && definition.type == 'image') {
						node.name = 'wa5-image';
						node.attributes = [
							{name: 'width', value: definition.width + ""},
							{name: 'height', value: definition.height + ""},
							{name: 'id', value: definition.id + ""},
							{name: 'filename', value: definition.filename + ""},
							{name: 'ownwork', value: definition.ownwork ? 'yes' : 'no'},
							{name: 'license', value: definition.license + ""},
							{name: 'author', value: definition.author + ""},
							{name: 'source', value: definition.source + ""},
							{name: 'src_w', value: definition.src_w + ""},
							{name: 'src_h', value: definition.src_h + ""},
							{name: 'src_x', value: definition.src_x + ""},
							{name: 'src_y', value: definition.src_y + ""}];
						if (styleAttr)
							node.attributes.push(styleAttr);
					}
				}

				if ((node = node.firstChild)) {
					do {
						walk(node);
					} while ((node = node.next));
				}
			}
		});
	});
});

